export enum PMStatus {
  arranging = 0,
  confirmed = 1,
  completed = 2,
  cancelled = 3
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/enum/pm-status.ts